<opac-table-cell-text>
  <ng-content></ng-content>
</opac-table-cell-text>
